import type { ResolvedRoute } from 'components/ferret/Ferret.utils';

interface HeroTitleProps {
  title: string;
  titleValues?: Record<string, string>;
}

function getRouteHeadline(
  title: string,
  translations: Record<string, string>
): string | null {
  const headlineKey = title.match(/^\{([^{}]+)\.headline\}$/)?.[1];
  if (!headlineKey) return null;

  const routeHeadlineKey = `${headlineKey}.routeHeadline`;
  return translations[routeHeadlineKey] ? `{${routeHeadlineKey}}` : null;
}

export function getHeroTitleProps(
  title: string,
  translations: Record<string, string>,
  route: ResolvedRoute | null
): HeroTitleProps {
  if (!route) return { title };

  const routeHeadline = getRouteHeadline(title, translations);
  if (!routeHeadline) return { title };

  return {
    title: routeHeadline,
    titleValues: {
      arrival: route.arrival.displayName,
      departure: route.departure.displayName,
    },
  };
}
